export function getPlain<T = any>(state: State | T): T {
  if (!state) return state
  return state instanceof Object && 'toJS' in state ? state.toJS() : state
}

// NOW shops carry `isInEU` in `shop.attributes`; the top-level field is only a fallback.
export function selectIsInEU(state: State): boolean {
  const shop = state.get('shop')
  if (!shop) return false
  const fromAttribute = shop
    .get('attributes', [])
    .find((attribute: ImmutableMap) => attribute.get('name') === 'isInEU')
    ?.get('value')
  return Boolean(fromAttribute ?? shop.get('isInEU'))
}

/**
 * The theme settings the storefront renders: the editor's preview while one
 * exists, otherwise the persisted settings.
 */
export function selectThemeSettings(state: State): ImmutableMap | undefined {
  return state.getIn(['view', 'themeSettingsPreview']) ?? state.getIn(['shop', 'themeSettings'])
}

/**
 * The theme settings as saved on the server, unaffected by editor previews.
 */
export function selectPersistedThemeSettings(state: State): ImmutableMap | undefined {
  return state.getIn(['shop', 'themeSettings'])
}
